import Vue from 'vue'
import Toasted from 'vue-toasted';
import '@mdi/font/css/materialdesignicons.css'
import './plugins/vee-validate';

import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import store from './store';


Vue.config.productionTip = false

Vue.use(Toasted, {
  theme: "toasted-primary",
  position: "bottom-center",
  duration : 3000,
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
